import axios from 'axios';

export const testBicValidator = async (code: string): Promise<string> => {
  try {
    const response = await axios.post(`/swift-bic/code`, { code });
    return response.data;
  } catch (error: any) {
    throw new Error('Error to find BIC', error.message);
  }
};
